// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StoreIdRouteImport } from './routes/$storeId'
import { Route as AppRouteImport } from './routes/app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as FounderRouteImport } from './routes/founder'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as StoreIdIndexRouteImport } from './routes/$storeId/index'
import { Route as StoreIdSlugRouteImport } from './routes/$storeId/$slug'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppStoreIdRouteImport } from './routes/app/$storeId'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as BlogSlugRouteImport } from './routes/blog/$slug'
import { Route as ForgotPasswordResetRouteImport } from './routes/forgot-password_/reset'
import { Route as FounderIndexRouteImport } from './routes/founder/index'
import { Route as FounderSigninRouteImport } from './routes/founder/signin'
import { Route as FounderStoresRouteImport } from './routes/founder/stores'
import { Route as FounderSupportRouteImport } from './routes/founder/support'
import { Route as SignupIndexRouteImport } from './routes/signup/index'
import { Route as AppStoreIdIndexRouteImport } from './routes/app/$storeId/index'
import { Route as AppStoreIdAccountRouteImport } from './routes/app/$storeId/account'
import { Route as AppStoreIdEmailHistoryRouteImport } from './routes/app/$storeId/email-history'
import { Route as AppStoreIdErrorRouteImport } from './routes/app/$storeId/error'
import { Route as AppStoreIdNoShowBookingsRouteImport } from './routes/app/$storeId/no-show-bookings'
import { Route as AppStoreIdNotificationsRouteImport } from './routes/app/$storeId/notifications'
import { Route as AppStoreIdPendingBookingsRouteImport } from './routes/app/$storeId/pending-bookings'
import { Route as AppStoreIdSupportRouteImport } from './routes/app/$storeId/support'
import { Route as BookingCancelTokenRouteImport } from './routes/booking/cancel/$token'
import { Route as BookingFeedbackTokenRouteImport } from './routes/booking/feedback/$token'
import { Route as FounderDemoIndexRouteImport } from './routes/founder/demo/index'
import { Route as FounderDemoCreateRouteImport } from './routes/founder/demo/create'
import { Route as FounderStoresIndexRouteImport } from './routes/founder/stores/index'
import { Route as FounderStoresStoreIdRouteImport } from './routes/founder/stores/$storeId'
import { Route as FounderSupportIndexRouteImport } from './routes/founder/support/index'
import { Route as FounderSupportTicketIdRouteImport } from './routes/founder/support/$ticketId'
import { Route as AppStoreIdReportsCancellationRouteImport } from './routes/app/$storeId/reports/cancellation'
import { Route as AppStoreIdReportsDailyRouteImport } from './routes/app/$storeId/reports/daily'
import { Route as AppStoreIdReportsDayOfWeekRouteImport } from './routes/app/$storeId/reports/day-of-week'
import { Route as AppStoreIdReportsFeedbackRouteImport } from './routes/app/$storeId/reports/feedback'
import { Route as AppStoreIdReportsHeatmapRouteImport } from './routes/app/$storeId/reports/heatmap'
import { Route as AppStoreIdReportsMonthlyRouteImport } from './routes/app/$storeId/reports/monthly'
import { Route as AppStoreIdReportsYearlyRouteImport } from './routes/app/$storeId/reports/yearly'
import { Route as AppStoreIdSettingsBillingRouteImport } from './routes/app/$storeId/settings/billing'
import { Route as AppStoreIdSettingsBookingSettingsRouteImport } from './routes/app/$storeId/settings/booking-settings'
import { Route as AppStoreIdSettingsBookingTimeRouteImport } from './routes/app/$storeId/settings/booking-time'
import { Route as AppStoreIdSettingsHouseRulesRouteImport } from './routes/app/$storeId/settings/house-rules'
import { Route as AppStoreIdSettingsStoreRouteImport } from './routes/app/$storeId/settings/store'
import { Route as AppStoreIdSettingsTablesRouteImport } from './routes/app/$storeId/settings/tables'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const StoreIdRoute = StoreIdRouteImport.update({
            id: '/$storeId',path: '/$storeId',getParentRoute: () => rootRouteImport
          })
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const FounderRoute = FounderRouteImport.update({
            id: '/founder',path: '/founder',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const StoreIdIndexRoute = StoreIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => StoreIdRoute
          })
const StoreIdSlugRoute = StoreIdSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => StoreIdRoute
          })
const AppIndexRoute = AppIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          })
const AppStoreIdRoute = AppStoreIdRouteImport.update({
            id: '/$storeId',path: '/$storeId',getParentRoute: () => AppRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordResetRoute = ForgotPasswordResetRouteImport.update({
            id: '/forgot-password_/reset',path: '/forgot-password/reset',getParentRoute: () => rootRouteImport
          })
const FounderIndexRoute = FounderIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FounderRoute
          })
const FounderSigninRoute = FounderSigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => FounderRoute
          })
const FounderStoresRoute = FounderStoresRouteImport.update({
            id: '/stores',path: '/stores',getParentRoute: () => FounderRoute
          })
const FounderSupportRoute = FounderSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => FounderRoute
          })
const SignupIndexRoute = SignupIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => SignupRoute
          })
const AppStoreIdIndexRoute = AppStoreIdIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdAccountRoute = AppStoreIdAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdEmailHistoryRoute = AppStoreIdEmailHistoryRouteImport.update({
            id: '/email-history',path: '/email-history',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdErrorRoute = AppStoreIdErrorRouteImport.update({
            id: '/error',path: '/error',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdNoShowBookingsRoute = AppStoreIdNoShowBookingsRouteImport.update({
            id: '/no-show-bookings',path: '/no-show-bookings',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdNotificationsRoute = AppStoreIdNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdPendingBookingsRoute = AppStoreIdPendingBookingsRouteImport.update({
            id: '/pending-bookings',path: '/pending-bookings',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdSupportRoute = AppStoreIdSupportRouteImport.update({
            id: '/support',path: '/support',getParentRoute: () => AppStoreIdRoute
          })
const BookingCancelTokenRoute = BookingCancelTokenRouteImport.update({
            id: '/booking/cancel/$token',path: '/booking/cancel/$token',getParentRoute: () => rootRouteImport
          })
const BookingFeedbackTokenRoute = BookingFeedbackTokenRouteImport.update({
            id: '/booking/feedback/$token',path: '/booking/feedback/$token',getParentRoute: () => rootRouteImport
          })
const FounderDemoIndexRoute = FounderDemoIndexRouteImport.update({
            id: '/demo/',path: '/demo/',getParentRoute: () => FounderRoute
          })
const FounderDemoCreateRoute = FounderDemoCreateRouteImport.update({
            id: '/demo/create',path: '/demo/create',getParentRoute: () => FounderRoute
          })
const FounderStoresIndexRoute = FounderStoresIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FounderStoresRoute
          })
const FounderStoresStoreIdRoute = FounderStoresStoreIdRouteImport.update({
            id: '/$storeId',path: '/$storeId',getParentRoute: () => FounderStoresRoute
          })
const FounderSupportIndexRoute = FounderSupportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FounderSupportRoute
          })
const FounderSupportTicketIdRoute = FounderSupportTicketIdRouteImport.update({
            id: '/$ticketId',path: '/$ticketId',getParentRoute: () => FounderSupportRoute
          })
const AppStoreIdReportsCancellationRoute = AppStoreIdReportsCancellationRouteImport.update({
            id: '/reports/cancellation',path: '/reports/cancellation',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdReportsDailyRoute = AppStoreIdReportsDailyRouteImport.update({
            id: '/reports/daily',path: '/reports/daily',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdReportsDayOfWeekRoute = AppStoreIdReportsDayOfWeekRouteImport.update({
            id: '/reports/day-of-week',path: '/reports/day-of-week',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdReportsFeedbackRoute = AppStoreIdReportsFeedbackRouteImport.update({
            id: '/reports/feedback',path: '/reports/feedback',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdReportsHeatmapRoute = AppStoreIdReportsHeatmapRouteImport.update({
            id: '/reports/heatmap',path: '/reports/heatmap',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdReportsMonthlyRoute = AppStoreIdReportsMonthlyRouteImport.update({
            id: '/reports/monthly',path: '/reports/monthly',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdReportsYearlyRoute = AppStoreIdReportsYearlyRouteImport.update({
            id: '/reports/yearly',path: '/reports/yearly',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdSettingsBillingRoute = AppStoreIdSettingsBillingRouteImport.update({
            id: '/settings/billing',path: '/settings/billing',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdSettingsBookingSettingsRoute = AppStoreIdSettingsBookingSettingsRouteImport.update({
            id: '/settings/booking-settings',path: '/settings/booking-settings',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdSettingsBookingTimeRoute = AppStoreIdSettingsBookingTimeRouteImport.update({
            id: '/settings/booking-time',path: '/settings/booking-time',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdSettingsHouseRulesRoute = AppStoreIdSettingsHouseRulesRouteImport.update({
            id: '/settings/house-rules',path: '/settings/house-rules',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdSettingsStoreRoute = AppStoreIdSettingsStoreRouteImport.update({
            id: '/settings/store',path: '/settings/store',getParentRoute: () => AppStoreIdRoute
          })
const AppStoreIdSettingsTablesRoute = AppStoreIdSettingsTablesRouteImport.update({
            id: '/settings/tables',path: '/settings/tables',getParentRoute: () => AppStoreIdRoute
          })





const StoreIdRouteChildren = {
  StoreIdSlugRoute: StoreIdSlugRoute,StoreIdIndexRoute: StoreIdIndexRoute
}

const StoreIdRouteWithChildren = StoreIdRoute._addFileChildren(StoreIdRouteChildren)




const AppStoreIdRouteChildren = {
  AppStoreIdAccountRoute: AppStoreIdAccountRoute,AppStoreIdEmailHistoryRoute: AppStoreIdEmailHistoryRoute,AppStoreIdErrorRoute: AppStoreIdErrorRoute,AppStoreIdNoShowBookingsRoute: AppStoreIdNoShowBookingsRoute,AppStoreIdNotificationsRoute: AppStoreIdNotificationsRoute,AppStoreIdPendingBookingsRoute: AppStoreIdPendingBookingsRoute,AppStoreIdSupportRoute: AppStoreIdSupportRoute,AppStoreIdIndexRoute: AppStoreIdIndexRoute,AppStoreIdReportsCancellationRoute: AppStoreIdReportsCancellationRoute,AppStoreIdReportsDailyRoute: AppStoreIdReportsDailyRoute,AppStoreIdReportsDayOfWeekRoute: AppStoreIdReportsDayOfWeekRoute,AppStoreIdReportsFeedbackRoute: AppStoreIdReportsFeedbackRoute,AppStoreIdReportsHeatmapRoute: AppStoreIdReportsHeatmapRoute,AppStoreIdReportsMonthlyRoute: AppStoreIdReportsMonthlyRoute,AppStoreIdReportsYearlyRoute: AppStoreIdReportsYearlyRoute,AppStoreIdSettingsBillingRoute: AppStoreIdSettingsBillingRoute,AppStoreIdSettingsBookingSettingsRoute: AppStoreIdSettingsBookingSettingsRoute,AppStoreIdSettingsBookingTimeRoute: AppStoreIdSettingsBookingTimeRoute,AppStoreIdSettingsHouseRulesRoute: AppStoreIdSettingsHouseRulesRoute,AppStoreIdSettingsStoreRoute: AppStoreIdSettingsStoreRoute,AppStoreIdSettingsTablesRoute: AppStoreIdSettingsTablesRoute
}

const AppStoreIdRouteWithChildren = AppStoreIdRoute._addFileChildren(AppStoreIdRouteChildren)



const AppRouteChildren = {
  AppStoreIdRoute: AppStoreIdRouteWithChildren,AppIndexRoute: AppIndexRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const FounderStoresRouteChildren = {
  FounderStoresStoreIdRoute: FounderStoresStoreIdRoute,FounderStoresIndexRoute: FounderStoresIndexRoute
}

const FounderStoresRouteWithChildren = FounderStoresRoute._addFileChildren(FounderStoresRouteChildren)




const FounderSupportRouteChildren = {
  FounderSupportTicketIdRoute: FounderSupportTicketIdRoute,FounderSupportIndexRoute: FounderSupportIndexRoute
}

const FounderSupportRouteWithChildren = FounderSupportRoute._addFileChildren(FounderSupportRouteChildren)



const FounderRouteChildren = {
  FounderSigninRoute: FounderSigninRoute,FounderStoresRoute: FounderStoresRouteWithChildren,FounderSupportRoute: FounderSupportRouteWithChildren,FounderIndexRoute: FounderIndexRoute,FounderDemoCreateRoute: FounderDemoCreateRoute,FounderDemoIndexRoute: FounderDemoIndexRoute
}

const FounderRouteWithChildren = FounderRoute._addFileChildren(FounderRouteChildren)




const SignupRouteChildren = {
  SignupIndexRoute: SignupIndexRoute
}

const SignupRouteWithChildren = SignupRoute._addFileChildren(SignupRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,StoreIdRoute: StoreIdRouteWithChildren,AppRoute: AppRouteWithChildren,ForgotPasswordRoute: ForgotPasswordRoute,FounderRoute: FounderRouteWithChildren,LoginRoute: LoginRoute,OnboardingRoute: OnboardingRoute,PrivacyRoute: PrivacyRoute,SigninRoute: SigninRoute,SignupRoute: SignupRouteWithChildren,TermsRoute: TermsRoute,BlogSlugRoute: BlogSlugRoute,ForgotPasswordResetRoute: ForgotPasswordResetRoute,BlogIndexRoute: BlogIndexRoute,BookingCancelTokenRoute: BookingCancelTokenRoute,BookingFeedbackTokenRoute: BookingFeedbackTokenRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)